/**
 * @fileoverview Layout component.
 * @summary Main layout wrapper with header and footer.
 *
 * @package KaraoNow
 * @module apps/front/src/components/Layout/Layout
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import Header from './Header.js'
import Spinner from '../Spinner.js'

/**
 * @summary Layout component.
 * @returns {React.ReactElement} Layout with header and content.
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 */
export default function Layout() {
  return (
    <div className="min-h-screen page-background">
      <Header />
      <main className="container">
        <Suspense fallback={<Spinner />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  )
}
